// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sm-lookup {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ── Barcode row ─────────────────────────────── */
.barcode-row {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.barcode-input {
  flex: 1 1 auto;
}

.lookup-btn {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
}

/* ── Banners ──────────────────────────────────── */
.sm-alert {
  font-size: 0.8125rem;
  padding: 0.35rem 0.6rem;
  border-radius: 4px;
}
.sm-alert--warning {
  background: #fff3cd;
  border: 1px solid #ffc107;
  color: #664d03;
}
.sm-alert--danger {
  background: #f8d7da;
  border: 1px solid #f5c2c7;
  color: #842029;
}

/* ── Result card ─────────────────────────────── */
.sm-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.6rem 0.8rem;
}

.sm-card-grid {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.2rem 0.75rem;
  font-size: 0.8125rem;
}

.sm-card-label {
  color: #6c757d;
  white-space: nowrap;
  font-weight: 500;
}

.sm-card-value {
  word-break: break-word;
}
.sm-card-value--mono {
  font-family: monospace;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/sample-manager-lookup/sample-manager-lookup.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEF;;AACA,mDAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAEF;;AACA,oDAAA;AACA;EACE,oBAAA;EACA,uBAAA;EACA,kBAAA;AAEF;AAAE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAEJ;AACE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AACJ;;AAGA,mDAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;AAEE;EACE,sBAAA;AAAJ","sourcesContent":[".sm-lookup {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* ── Barcode row ─────────────────────────────── */\n.barcode-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.barcode-input {\n  flex: 1 1 auto;\n}\n\n.lookup-btn {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2rem;\n}\n\n/* ── Banners ──────────────────────────────────── */\n.sm-alert {\n  font-size: 0.8125rem;\n  padding: 0.35rem 0.6rem;\n  border-radius: 4px;\n\n  &--warning {\n    background: #fff3cd;\n    border: 1px solid #ffc107;\n    color: #664d03;\n  }\n\n  &--danger {\n    background: #f8d7da;\n    border: 1px solid #f5c2c7;\n    color: #842029;\n  }\n}\n\n/* ── Result card ─────────────────────────────── */\n.sm-card {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 0.6rem 0.8rem;\n}\n\n.sm-card-grid {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: 0.2rem 0.75rem;\n  font-size: 0.8125rem;\n}\n\n.sm-card-label {\n  color: #6c757d;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.sm-card-value {\n  word-break: break-word;\n\n  &--mono {\n    font-family: monospace;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
